import React, { type FC } from 'react'
import { Status } from 'shared/ui'
import type { IStatusProps } from 'shared/ui/Status'
import { EmptyCell } from 'shared/ui/Table'
import type { ICallingListResponse } from 'entities/AICalling/api/types'
import { getAiCallingStatus } from './config'

type IAiCallingStatusProps = {
  status: ICallingListResponse['status']
  emphasis?: IStatusProps['emphasis']
  onlyIcon?: IStatusProps['onlyIcon']
}

export const AiCallingStatus: FC<IAiCallingStatusProps> = ({
  status,
  emphasis = 'high',
  onlyIcon,
}) => {
  const statusProps = getAiCallingStatus(status)

  return statusProps ? (
    <Status {...statusProps} emphasis={emphasis} onlyIcon={onlyIcon} />
  ) : (
    <EmptyCell />
  )
}
